import { logException } from "@allwyn/utils/logger/use-app-logger";
import { InterfaceName, MobileAppMethodName } from "./mobile-app-models";
import useWebviewDebugMode from "./use-webview-debug";

const { initWebviewDebugMode, showEventAlert } = useWebviewDebugMode();

export function triggerMobileAppEvent(
    methodName: MobileAppMethodName,
    argument?: string,
    interfaceName?: InterfaceName
): void;
export function triggerMobileAppEvent(methodName: string, argument?: string, interfaceName?: InterfaceName): void;
export function triggerMobileAppEvent(
    methodName: string,
    argument?: string,
    interfaceName: InterfaceName = "generalIntegration"
): void {
    const anyWindow = window as any;

    if (methodName === "openInBrowser") {
        methodName = "openLinkBrowser";
    }

    try {
        // for iOS WebKit
        if (typeof anyWindow.webkit !== "undefined") {
            showEventAlert(interfaceName, methodName, argument);
            argument !== null && argument !== undefined
                ? anyWindow.webkit.messageHandlers[interfaceName].postMessage(
                      JSON.stringify({ type: methodName, parameters: argument })
                  )
                : anyWindow.webkit.messageHandlers[interfaceName]?.postMessage(JSON.stringify({ type: methodName }));
        }

        // for Android WebView
        const androindInterface = anyWindow[interfaceName];
        // eslint-disable-next-line no-prototype-builtins
        if (androindInterface?.hasOwnProperty(methodName)) {
            showEventAlert(interfaceName, methodName, argument);
            argument !== null && argument !== undefined
                ? androindInterface[methodName](argument)
                : androindInterface[methodName]();
        }
    } catch (e) {
        logException("mobile-app-integration-error", e, {
            interfaceName,
            methodName,
            argument,
            interface: anyWindow.webkit ?? anyWindow[interfaceName],
        });
    }

    // TODO remove after Adastra deploy
    if (interfaceName == "generalIntegration") {
        triggerMobileAppEvent(methodName, argument, "bannerIntegration");
        triggerMobileAppEvent(methodName, argument, "goldenWheelIntegration");
    }
}

function initAutoMobileAppEvents() {
    document.querySelectorAll("[data-app-event]:not([data-app-event=''])").forEach((item) => {
        item.addEventListener("click", (e) => {
            e.preventDefault();
            const eventName = (e.currentTarget as HTMLElement).getAttribute("data-app-event");
            const argument = (e.currentTarget as HTMLElement).getAttribute("data-app-argument");

            triggerMobileAppEvent(eventName, argument);
        });
    });
}

export function getAllwynAppName() {
    return environment.appName === "sazka" ? "allwyn" : environment.appName;
}

export function initMobileAppFeatures() {
    if (environment.webView.isAppWebView) {
        initAutoMobileAppEvents();

        // WebView Debug Mode
        initWebviewDebugMode();
    }
}
